import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";

@Injectable()
export class EnterpIntroductionServiceService {
  isFromQi: boolean;//是否从企查查接口获取数据
  baseUrl: string;

  constructor(private http: HttpCommonService) {
    this.isFromQi = false;
  }

  //控制tab样式
  updateTabActive(i) {
    setTimeout(function () {
      $("#tabUL").find("li").eq(i).addClass("TabActive").siblings().removeClass("TabActive");
    },100);
  }

  getCompanyName(companyId): any {
    return this.http.get("/enterprise/detail/xhsRest/baseMsg/getCompanyInfo", {"companyId": companyId});
  }

  getCompanyByName(companyName): any {
    return this.http.get("/user/center/xhsRest/getCompanyByName", {"companyName": companyName});
  }

  getCompany(companyId, companyName?, isFromDetail?): any {
    this.baseUrl = this.isFromQi ? '/enterprise/detail/xhsRest/baseByQi' : '/enterprise/detail/xhsRest/baseMsg';
    return this.http.get(this.baseUrl + "/getCompanyInfo", {companyId: companyId, companyName: companyName, isFromDetail: isFromDetail});
  }

  //查询基础档案信息 注释q代表有企查查接口
  getBasicInfo(params: any, type: number) {
    this.baseUrl = this.isFromQi ? '/enterprise/detail/xhsRest/baseByQi' : '/enterprise/detail/xhsRest/baseMsg';
    if (!params.page) {
      return {'totals': 0, data: []};
    }
    let url = this.baseUrl;
    //此处过滤一下，有些数据是企查查没有接口的，调用正常的接口方法
    if (type == 24) {
      url = '/enterprise/detail/xhsRest/baseMsg';
    }
    switch (type) {
      case 1:  //股权结构-q
        // url += this.isFromQi ? '/getCompanyInfo' : '/getCompanyPartnersByPage';
        url += '/getCompanyPartnersByPage';
        break;
      case 2: //对外投资-q
        url += '/getOperationInvestInfoByPage';
        break;
      case 3: //分支机构-q
        // url += this.isFromQi ? '/getCompanyInfo' : '/getCompanyBranchesByPage';
        url += '/getCompanyBranchesByPage';
        break;
      case 4: //工商记录变更-q
        // url += this.isFromQi ? '/getCompanyChangeRecords' : '/getCompanyChangeRecordsByPage';
        url += '/getCompanyChangeRecordsByPage';
        break;
      case 5: //经营范围变更-q
        // url += this.isFromQi ? '/getCompanyChangeScope' : '/getCompanyChangeScopeByPage';
        url += '/getCompanyChangeScopeByPage';
        break;
      case 6: //专利信息-q
        url += '/getAssetPatentDetailByPage';
        break;
      case 7: //软件著作权信息-q
        url += '/getOperationSoftwareCopyrightsByPage';
        break;
      case 8: //商标信息-q
        url += '/getAssetTmInfoByPage';
        break;
      case 9: //动产抵押
        url += '/getOperationMpledgeByPage';
        break;
      case 10: //股权出质
        url += '/getOperationPledgeByPage';
        break;
      case 11: //工商异常名录-q
        // url += this.isFromQi ? '/getCompanyOpexception' : '/getCompanyOpexceptionByPage';
        url += '/getCompanyOpexceptionByPage';
        break;
      case 12: //被执行人信息-q
        url += '/getAssetZhiXingByPage';
        break;
      case 13: //失信被执行信息-q
        url += '/getAssetShiXinByPage';
        break;
      case 14: //裁判文书信息-q
        url += '/getAssetCaseByPage';
        break;
      case 15: //法院公告信息-q
        url += '/getAssetChinacourtByPage';
        break;
      case 16: //企业舆情信息-q
        url += '/getOperationNewsInfoByPage';
        break;
      case 17: //招聘信息-q
        url += '/getOperationRecruitInfoByPage';
        break;
      case 18: //清算信息-q
        url += '/getOperationLiquidationByPage';
        break;
      case 19: //招投标信息-q
        url += '/getOperationTenderInfoByPage';
        break;
      case 20: //著作权信息-q
        url += '/getOperationCopyrightByPage';
        break;
      case 21: //网站信息-q
        url += '/getOperationWebsiteByPage';
        break;
      case 22: //证书信息-q
        url += '/getAssetCertificationByPage';
        break;
      case 23: //融资信息-q
        url += '/getOperationFinancingByPage';
        break;
      case 24: //财务信息
        url += '/getOperationFinancingTaxByPage';
        break;
      case 25: //产品信息-q
        url += '/getOperationProductByPage';
        break;
      case 26: //抽查信息
        url += '/getOperationSpotcheckByPage';
        break;
      case 27: //行政处罚信息
        url += '/getDetailOperationPenaltyByPage';
        break;
    }

    if (type == 11 && this.isFromQi) {
      return this.http.get("/enterprise/detail/xhsRest/baseByQi/getCompanyInfo", {companyName: params.companyName})
        .mergeMap(result => {
          // return this.http.get(url, {keyNo: result.data.Result.KeyNo})
          return this.http.get(url, {keyNo: result.data.Result.KeyNo,
            "pageSize": params.page.pageSize, "pageNo": params.page.pageNo});
        });
    }

    return this.http.get(url, {
      "companyId": params.companyId, "companyName": params.companyName,
      "pageSize": params.page.pageSize, "pageNo": params.page.pageNo,
    });
  }

}

//基础信息
export class Company {
  public companyId: string;
  public name: string;
  public creditCode: string;
  public operName: string;
  public econKind: string;
  public industry: string;
  public startDate: string;
  public checkDate: string;
  public rawRegistCapi: string;
  public termStart: string;
  public termEnd: string;
  public scope: string;
  public address: string;
  public belongOrg: string;
  public imgUrl: string;
  public status: string;
  public email: string;
  public registCapi: string;
  public no: string;
  public webUrl: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name = item.Name;
      this.status = item.Status;
      this.imgUrl = item.imgUrl;
      this.creditCode = item.CreditCode;
      this.operName = item.OperName;
      this.startDate = item.StartDate;
      this.email = item.ContactInfo ? item.ContactInfo.Email : "";
      this.address = item.Address;
      this.checkDate = item.CheckDate;
      this.registCapi = item.RegistCapi;
      this.econKind = item.EconKind;
      this.belongOrg = item.BelongOrg;
      this.scope = item.Scope;
      this.no = item.No;
      this.webUrl = item.ContactInfo ? (item.ContactInfo.WebSite ? item.ContactInfo.WebSite[0].Url : '') : '';
    } else {
      this.companyId = item.id;
      this.name = item.name;
      this.imgUrl = item.imgUrl;
      this.status = item.status;
      this.creditCode = item.creditCode;
      this.operName = item.operName;
      this.startDate = item.startDate;
      this.email = item.email;
      this.address = item.address;
      this.checkDate = item.checkDate;
      this.registCapi = item.registCapi;
      this.econKind = item.econKind;
      this.belongOrg = item.belongOrg;
      this.scope = item.scope;
      this.no = item.no;
    }
  }
}

//股东及出资方
export class CompanyPartner {
  public stockName: string;
  public shouldCapi: string;
  public realCapi: string;
  public stockPercent: string;
  public investName: string;
  public identifyNo: string;
  public isCompany:boolean;

  constructor(item, isFromQi) {
    this.isCompany = false;
    if (isFromQi) {
      this.stockName = item.StockName;
      this.shouldCapi = item.ShouldCapi;
      this.stockPercent = item.StockPercent;
      this.investName = item.InvestType;
      this.realCapi = item.RealCapi;
      this.identifyNo = item.identifyNo;
    } else {
      this.stockName = item.stockName;
      this.shouldCapi = item.shouldCapi;
      this.realCapi = item.realCapi;
      this.stockPercent = item.stockPercent;
      this.investName = item.investName;
      this.identifyNo = item.identifyNo;
    }
  }
}

//对外投资
export class InvestInfo {
  public name: string;
  public registCapi: string;
  public no: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name = item.Name;
      this.registCapi = item.RegistCapi;
      this.no = item.CreditCode ? item.CreditCode : item.No;
    } else {
      this.name = item.name;
      this.registCapi = item.registCapi;
      this.no = item.no;
    }
  }
}

//分支机构
export class Branch {
  public name: string;
  public operName: string;
  public creditCode: string;
  public belongOrg: string;
  public isCompany = false;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name = item.Name;
      this.creditCode = item.RegNo;
      this.belongOrg = item.BelongOrg;
    } else {
      this.name = item.name;
      this.operName = item.operName;
      this.creditCode = item.branchCreditCode;
      this.belongOrg = item.belongOrg;
    }
  }
}

//工商变更记录
export class Change {
  public projectName: string;
  public beforeContent: string;
  public afterContent: string;
  public changeDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.projectName = item.ProjectName;
      this.beforeContent = item.BeforeContent;
      this.afterContent = item.AfterContent;
      this.changeDate = item.ChangeDate;
    } else {
      this.projectName = item.projectName;
      this.beforeContent = item.beforeContent;
      this.afterContent = item.afterContent;
      this.changeDate = item.changeDate;
    }
  }
}

//经营范围变更
export class ScopeChange {
  public beforeContent: string;
  public afterContent: string;
  public changeDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.beforeContent = item.BeforeContent;
      this.afterContent = item.AfterContent;
      this.changeDate = item.ChangeDate;
    } else {
      this.beforeContent = item.beforeContent;
      this.afterContent = item.afterContent;
      this.changeDate = item.changeDate;
    }
  }
}

//专利信息
export class PatentDetail {
  public title: string;
  public publicationNumber: string;
  public kindCodeDesc: string;
  public pubDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.title = item.Title;
      this.publicationNumber = item.PublicationNumber;
      this.kindCodeDesc = item.KindCodeDesc;
      this.pubDate = item.PublicationDate;
    } else {
      this.title = item.title;
      this.publicationNumber = item.publicationNumber;
      this.kindCodeDesc = item.kindCodeDesc;
      this.pubDate = item.pubDate;
    }
  }
}

//软件著作权信息
export class SoftwareCopyrights {
  public name: string;
  public registerNo: string;
  public companyName: string;
  public registerAperDate: string;
  public category: string;
  public publishDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name = item.Name;
      this.registerNo = item.RegisterNo;
      this.companyName = item.Owner;
      this.registerAperDate = item.RegisterAperDate;
      this.category = item.Category;
      this.publishDate = item.PublishDate;
    } else {
      this.name = item.name;
      this.registerNo = item.registerNo;
      this.companyName = item.companyName;
      this.registerAperDate = item.registerAperDate;
      this.category = item.category;
      this.publishDate = item.publishDate;
    }
  }
}

//商标信息
export class TmInfo {
  public name: string;
  public imageUrl: string;
  public regno: string;
  public appDate: string;
  public applicantCn: string;
  public intClsDesc: string;
  public status: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name = item.Name;
      this.imageUrl = item.ImageUrl;
      this.regno = item.RegNo;
      this.appDate = item.AppDate;
      this.applicantCn = item.ApplicantCn;
      this.intClsDesc = this.getIntClsDesc(item.IntCls);
      this.status = item.Status;
    } else {
      this.name = item.name;
      this.imageUrl = item.imageUrl;
      this.regno = item.regno;
      this.appDate = item.appDate;
      this.applicantCn = item.applicantCn;
      this.intClsDesc = item.intClsDesc;
      this.status = item.status;
    }
  }

  getIntClsDesc(intCls: string): string {
    let intClsDesc = "";
    if (intCls) {
      switch (String(intCls)) {
        case "1" :
          intClsDesc = "化学原料";
          break;
        case "2" :
          intClsDesc = "颜料油漆";
          break;
        case "3" :
          intClsDesc = "日化用品";
          break;
        case "4" :
          intClsDesc = "燃料油脂";
          break;
        case "5" :
          intClsDesc = "医药";
          break;
        case "6" :
          intClsDesc = "金属材料";
          break;
        case "7" :
          intClsDesc = "机械设备";
          break;
        case "8" :
          intClsDesc = "手工器械";
          break;
        case "9" :
          intClsDesc = "科学仪器";
          break;
        case "10" :
          intClsDesc = "医疗器械";
          break;
        case "11" :
          intClsDesc = "灯具空调";
          break;
        case "12" :
          intClsDesc = "运输工具";
          break;
        case "13" :
          intClsDesc = "军火烟火";
          break;
        case "14" :
          intClsDesc = "珠宝钟表";
          break;
        case "15" :
          intClsDesc = "乐器";
          break;
        case "16" :
          intClsDesc = "办公品";
          break;
        case "17" :
          intClsDesc = "橡胶制品";
          break;
        case "18" :
          intClsDesc = "皮革皮具";
          break;
        case "19" :
          intClsDesc = "建筑材料";
          break;
        case "20" :
          intClsDesc = "家具";
          break;
        case "21" :
          intClsDesc = "厨房洁具";
          break;
        case "22" :
          intClsDesc = "绳网袋篷";
          break;
        case "23" :
          intClsDesc = "纱线丝";
          break;
        case "24" :
          intClsDesc = "布料床单";
          break;
        case "25" :
          intClsDesc = "服装鞋帽";
          break;
        case "26" :
          intClsDesc = "钮扣拉链";
          break;
        case "27" :
          intClsDesc = "地毯席垫";
          break;
        case "28" :
          intClsDesc = "键身器材";
          break;
        case "29" :
          intClsDesc = "食品";
          break;
        case "30" :
          intClsDesc = "方便食品";
          break;
        case "31" :
          intClsDesc = "饲料种籽";
          break;
        case "32" :
          intClsDesc = "啤酒饮料";
          break;
        case "33" :
          intClsDesc = "酒";
          break;
        case "34" :
          intClsDesc = "烟草烟具";
          break;
        case "35" :
          intClsDesc = "广告销售";
          break;
        case "36" :
          intClsDesc = "金融物管";
          break;
        case "37" :
          intClsDesc = "建筑修理";
          break;
        case "38" :
          intClsDesc = "通讯服务";
          break;
        case "39" :
          intClsDesc = "运输贮藏";
          break;
        case "40" :
          intClsDesc = "材料加工";
          break;
        case "41" :
          intClsDesc = "教育娱乐";
          break;
        case "42" :
          intClsDesc = "设计研究";
          break;
        case "43" :
          intClsDesc = "餐饮住宿";
          break;
        case "44" :
          intClsDesc = "医疗园艺";
          break;
        case "45" :
          intClsDesc = "社会法律";
          break;
      }
    }
    return intClsDesc;
  }
}

//动产抵押
export class MPledge {
  public registerNo: string;
  public registerDate: string;
  public registerOffice: string;
  public debt_securedAmount: string;
  public status: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.registerNo = item.RegisterNo;
      this.registerDate = item.RegisterDate;
      this.registerOffice = item.RegisterOffice;
      this.debt_securedAmount = item.DebtSecuredAmount;
      this.status = item.Status;
    } else {
      this.registerNo = item.registerNo;
      this.registerDate = item.registerDate;
      this.registerOffice = item.registerOffice;
      this.debt_securedAmount = item.debt_securedAmount;
      this.status = item.status;
    }
  }
}

//股权出质
export class Pledge {
  public registNo: string;
  public pledgor: string;
  public pledgorNo: string;
  public pledgedAmount: string;
  public pledgee: string;
  public pledgeeNo: string;
  public regDate: string;
  public status: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.registNo = item.RegistNo;
      this.pledgor = item.Pledgor;
      this.pledgorNo = item.PledgorNo;
      this.pledgedAmount = item.PledgedAmount;
      this.pledgee = item.Pledgee;
      this.pledgeeNo = item.PledgeeNo;
      this.regDate = item.RegDate;
      this.status = item.Status;
    } else {
      this.registNo = item.registNo;
      this.pledgor = item.pledgor;
      this.pledgorNo = item.pledgorNo;
      this.pledgedAmount = item.pledgedAmount;
      this.pledgee = item.pledgee;
      this.pledgeeNo = item.pledgeeNo;
      this.regDate = item.regDate;
      this.status = item.status;
    }
  }
}

//工商异常名录
export class OpException {
  public addReason: string;
  public addDate: string;
  public romoveReason: string;
  public removeDate: string;
  public decisionOffice: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.addReason = item.AddReason;
      this.addDate = item.AddDate;
      this.romoveReason = item.RomoveReason;
      this.removeDate = item.RemoveDate;
      this.decisionOffice = item.DecisionOffice;
    } else {
      this.addReason = item.addReason;
      this.addDate = item.addDate;
      this.romoveReason = item.romoveReason;
      this.removeDate = item.removeDate;
      this.decisionOffice = item.decisionOffice;
    }
  }
}

//清算信息
export class Liquidation {
  public leader: string;
  public member: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.leader = item.Leader;
      this.member = item.Member;
    } else {
      this.leader = item.leader;
      this.member = item.member;
    }
  }
}

// 被执行人信息
export class Execute {
  public anNo: string;
  public executeGov: string;
  public biaoDi: string;
  public liAnDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.anNo = item.Anno;
      this.executeGov = item.ExecuteGov;
      this.biaoDi = item.Biaodi;
      this.liAnDate = item.Liandate;
    } else {
      this.anNo = item.anNo;
      this.executeGov = item.executeGov;
      this.biaoDi = item.biaoDi;
      this.liAnDate = item.liAnDate;
    }
  }
}

// 失信被执行人信息
export class LoseCreditExecute {
  public anNo: string;
  public executeStatus: string;
  public yiWu: string;
  public executeUnit: string;
  public publicDate: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.anNo = item.Anno;
      this.executeStatus = item.Executestatus;
      this.yiWu = item.Yiwu;
      this.executeUnit = item.Executegov;
      this.publicDate = item.Publicdate;
    } else {
      this.anNo = item.anNo;
      this.executeStatus = item.executeStatus;
      this.yiWu = item.yiWu;
      this.executeUnit = item.executeUnit;
      this.publicDate = item.publicDate;
    }
  }
}

// 裁判文书信息
export class CaseB {
  public caseNo: string;
  public caseName: string;
  public caseType: string;
  public court: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.caseNo = item.CaseNo;
      this.caseName = item.CaseName;
      this.caseType = item.CaseType;
      this.court = item.Court;
    } else {
      this.caseNo = item.caseNo;
      this.caseName = item.caseName;
      this.caseType = item.caseType;
      this.court = item.court;
    }
  }
}

// 法院公告信息
export class Chinacourt {
  public publicDate: string;
  public catagory: string;
  public litigant: string;
  public content: string;
  public isCompany:boolean;

  constructor(item, isFromQi) {
    this.isCompany = false;
    if (isFromQi) {
      this.publicDate = item.PublishedDate;
      this.catagory = item.Category;
      this.litigant = item.Party;
      this.content = item.Content;
    } else {
      this.publicDate = item.publicDate;
      this.catagory = item.catagory;
      this.litigant = item.litigant;
      this.content = item.content;
    }
  }
}

// 企业舆情信息
export class NewsInfo {
  public title: string;
  public publishTime: string;
  public source: string;
  public url: string;

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.title = item.Title;
      this.publishTime = item.PublishTime;
      this.source = item.Source;
      this.url = item.Url;
    } else {
      this.title = item.title;
      this.publishTime = item.publishTime;
      this.source = item.source;
      this.url = item.url;
    }
  }
}

// 招聘类信息
export class RecruitInfo {
  public title: string;
  public publishTime: string;
  public description: string;
  public source: string;
  public area: string;
  public salary: string;
  public education: string;
  public experience: string;
  constructor(item, isFromQi) {
    if (isFromQi) {
      this.title = item.Title;
      this.publishTime = item.PublishTime;
      this.description = item.Description;
      this.source = item.Source;
      this.area = item.Area;
      this.salary = item.Salary;
      this.education = item.Education;
      this.experience = item.Experience;
    } else {
      this.title = item.title;
      this.publishTime = item.publishTime;
      this.description = item.description;
      this.source = item.source;
      this.area = item.area;
      this.salary = item.salary;
      this.education = item.education;
      this.experience = item.experience;
    }
  }
}

// 招投标
export class OperationTender {
  public title: string;
  public publishTime: string;
  public provinceName: string;
  public channelName: string;


  constructor(item, isFromQi) {
    if (isFromQi) {
      this.title = item.Title;
      this.publishTime = item.Pubdate;
      this.provinceName = item.ProvinceName;
      this.channelName = item.ChannelName;
    } else {

    }
  }
}
//著作权信息
export class Copyright {
  public category : string;//分类
  public name : string;//名称
  public owner : string;//所属公司
  public registerNo : string;//登记号
  public registerDate : string;//登记日期
  public finishDate : string;//完成日期
  public publishDate : string;//发布时间

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.category = item.Category;
      this.name = item.Name;
      this.owner = item.Owner;
      this.registerNo = item.RegisterNo;
      this.registerDate = item.RegisterDate;
      this.finishDate = item.FinishDate;
      this.publishDate = item.PublishDate;
    } else {
      this.category = item.category;
      this.name = item.name;
      this.owner = item.owner;
      this.registerNo = item.registerNo;
      this.registerDate = item.registerDate;
      this.finishDate = item.finishDate;
      this.publishDate = item.publishDate;
    }
  }
}
//网站信息
export class Website {
  public homeSite : string;//网址
  public sDate : any;//审核时间
  public typeName : string;//网站类别
  public yuMing : string;//域名
  public beiAn : string;//网站备案
  public status : any;//状态，是否有效

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.homeSite = item.HomeSite;
      this.sDate = item.SDate;
      this.typeName = item.TypeName;
      this.yuMing = item.YuMing;
      this.beiAn = item.BeiAn;
      this.status = item.Status;
    } else {
      this.homeSite = item.homeSite;
      this.sDate = item.Name;
      this.typeName = item.typeName;
      this.yuMing = item.yuMing;
      this.beiAn = item.beiAn;
      this.status = item.status;
    }
  }
}
//证书信息
export class Certification {
  public name : string;//名称
  public startDate : string;//发证日期
  public standard : string;//标准
  public manufacturer : string;//制造商
  public currentState : string;//证书状态
  public productionPlant : string;//生产商
  public certificateNumber : string;//证书编号
  public applicant : string;//申请人

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.name  = item.Name;//名称
      this.startDate = item.StartDate;//发证日期
      // this.standard = item.;//标准
      // this.manufacturer = item.;//制造商
      // this.currentState = item.;//证书状态
      // this.productionPlant = item.;//生产商
      this.certificateNumber = item.No;//证书编号
      // this.applicant = item.;//申请人
    } else {
      this.name  = item.name;//名称
      this.startDate = item.startDate;//发证日期
      this.standard = item.standard;//标准
      this.manufacturer = item.manufacturer;//制造商
      this.currentState = item.currentState;//证书状态
      this.productionPlant = item.productionPlant;//生产商
      this.certificateNumber = item.certificateNumber;//证书编号
      this.applicant = item.applicant;//申请人
    }
  }
}
//融资信息
export class Financing {
  public date : any;//日期
  public amount : string;//金额
  public round : string;//级别
  public investment : string;//投资方

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.date  = item.Date;
      this.amount = item.Amount;
      this.round = item.Round;
      this.investment = item.Investment;
    } else {
      this.date  = item.date;
      this.amount = item.amount;
      this.round = item.round;
      this.investment = item.investment;
    }
  }
}
//财务信息
export class FinancingTax {
  public year : any;//财务年份
  public revenueRange : string;//公司实力等级
  public taxRange : string;//纳税区间
  public netProfitMargins : string;//销售净利润率
  public grossProfitMargins : string;//销售毛利率

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.year  = item.year;
      this.revenueRange = item.revenueRange;
      this.taxRange = item.taxRange;
      this.netProfitMargins = item.netProfitMargins;
      this.grossProfitMargins = item.grossProfitMargins;
    } else {
      this.year  = item.year;
      this.revenueRange = item.revenueRange;
      this.taxRange = item.taxRange;
      this.netProfitMargins = item.netProfitMargins;
      this.grossProfitMargins = item.grossProfitMargins;
    }
  }
}
//产品信息
export class Product {
  public link : string;// 网址
  public name : string;//名称
  public imageUrl : string;//图片链接
  public domain : string;//领域
  public tags : string;//标签
  public description : string;//描述
  public category : string;//分类 “-1”这个值没有实际含义
  public domainDesc : string;//领域

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.link  = item.Link;
      this.name = item.Name;
      this.imageUrl = item.ImageUrl;
      this.domain = item.Domain;
      this.tags = item.Tags;
      this.description = item.Description;
      this.category = item.Category;
      this.domainDesc = item.Domain;
    } else {
      this.link  = item.link;
      this.name = item.name;
      this.imageUrl = "http://img.qichacha.com/Product/" + item.imageUrl;
      this.domain = item.domain;
      this.tags = item.tags;
      this.description = item.description;
      this.category = item.category;
      this.domainDesc = item.domainDesc;
    }
  }

}
//抽查信息
export class Spotcheck {
  public executiveOrg : string;//检查实施机关
  public type : string;//类型
  public date : any;//日期

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.executiveOrg  = item.ExecutiveOrg;
      this.type = item.Type;
      this.date = item.Date;
    } else {
      this.executiveOrg  = item.executiveOrg;
      this.type = item.type;
      this.date = item.date;
    }
  }

}
//行政处罚信息
export class Penalty {
  public docNo : string;//文号
  public penaltyType : string;//类型
  public content : string;//处罚内容
  public officeName : string;//决定机关
  public penaltyDate : any;//决定日期

  constructor(item, isFromQi) {
    if (isFromQi) {
      this.docNo  = item.DocNo;
      this.penaltyType = item.PenaltyType;
      this.content = item.Content;
      this.officeName = item.OfficeName;
      this.penaltyDate = item.PenaltyDate;
    } else {
      this.docNo  = item.docNo;
      this.penaltyType = item.penaltyType;
      this.content = item.content;
      this.officeName = item.officeName;
      this.penaltyDate = item.penaltyDate;
    }
  }
}





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/enterp-introduction-service.service.ts